module.exports = __webpack_public_path__ + "img/icon-implantation-08.191fa7e4.svg";